import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  applyDocumentLang,
  DEFAULT_LANG,
  loadStoredLang,
  type AppLang,
} from './locale';

import commonFr from '../locales/fr/common.json';
import panelsFr from '../locales/fr/panels.json';
import newsFr from '../locales/fr/news.json';
import techsFr from '../locales/fr/techs.json';
import onuFr from '../locales/fr/onu.json';
import errorsFr from '../locales/fr/errors.json';
import tutorialFr from '../locales/fr/tutorial.json';

import commonEn from '../locales/en/common.json';
import panelsEn from '../locales/en/panels.json';
import newsEn from '../locales/en/news.json';
import techsEn from '../locales/en/techs.json';
import onuEn from '../locales/en/onu.json';
import errorsEn from '../locales/en/errors.json';
import tutorialEn from '../locales/en/tutorial.json';

import commonEs from '../locales/es/common.json';
import panelsEs from '../locales/es/panels.json';
import newsEs from '../locales/es/news.json';
import techsEs from '../locales/es/techs.json';
import onuEs from '../locales/es/onu.json';
import errorsEs from '../locales/es/errors.json';
import tutorialEs from '../locales/es/tutorial.json';

import commonDe from '../locales/de/common.json';
import panelsDe from '../locales/de/panels.json';
import newsDe from '../locales/de/news.json';
import techsDe from '../locales/de/techs.json';
import onuDe from '../locales/de/onu.json';
import errorsDe from '../locales/de/errors.json';
import tutorialDe from '../locales/de/tutorial.json';

export const I18N_NAMESPACES = [
  'common',
  'panels',
  'news',
  'techs',
  'onu',
  'errors',
  'tutorial',
] as const;

const resources = {
  fr: {
    common: commonFr,
    panels: panelsFr,
    news: newsFr,
    techs: techsFr,
    onu: onuFr,
    errors: errorsFr,
    tutorial: tutorialFr,
  },
  en: {
    common: commonEn,
    panels: panelsEn,
    news: newsEn,
    techs: techsEn,
    onu: onuEn,
    errors: errorsEn,
    tutorial: tutorialEn,
  },
  es: {
    common: commonEs,
    panels: panelsEs,
    news: newsEs,
    techs: techsEs,
    onu: onuEs,
    errors: errorsEs,
    tutorial: tutorialEs,
  },
  de: {
    common: commonDe,
    panels: panelsDe,
    news: newsDe,
    techs: techsDe,
    onu: onuDe,
    errors: errorsDe,
    tutorial: tutorialDe,
  },
} as const;

const initialLang = typeof window !== 'undefined' ? loadStoredLang() : DEFAULT_LANG;

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: DEFAULT_LANG,
  defaultNS: 'common',
  ns: [...I18N_NAMESPACES],
  interpolation: { escapeValue: false },
  returnNull: false,
});

applyDocumentLang(initialLang as AppLang);

i18n.on('languageChanged', (lng) => {
  const code = (lng?.split('-')[0] ?? DEFAULT_LANG) as AppLang;
  applyDocumentLang(code);
});

export default i18n;
